import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { AlertComponent } from '@components/atoms/alert/alert.component';
import { MedpaceTextareaAutocompleteComponent } from '@components/atoms/textarea-autocomplete/medpace-textarea-autocomplete.component';
import { TransferDataComponent } from '@components/molecules/forms/patient-travel-card/ground/transfer-data/transfer-data.component';
import {
    CarServiceRequestDetailsFormGroup,
    TransferDataFormGroup,
} from '@components/request/travel-request-card/form-groups/detail-form-groups/travel/car-service-request.formgroup';
import { MdsButtonComponent } from '@medpacesoftwaredevelopment/designsystem';
import { MedpaceAutocompleteObject } from '@models/medpaceAutocompleteObject';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { getUniqueObjects, MdsOptionGeneric } from '@utility/utility';

@Component({
    selector: 'medpace-transfer-request-details-edit',
    templateUrl: './transfer-request-details-edit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TransferDataComponent,
        AlertComponent,
        MdsButtonComponent,
        MedpaceTextareaAutocompleteComponent,
    ],
})
export class TransferRequestDetailsEditComponent {
    private readonly travelViewModelService = inject(TravelViewModelService);

    readonly formGroup: InputSignal<CarServiceRequestDetailsFormGroup> = input.required();

    public readonly autocompleteOptions: Signal<{
        specialRequests: MedpaceAutocompleteObject[];
    }> = computed(() => ({
        specialRequests: getUniqueObjects(
            this.travelViewModelService
                .travelCardViewModel()
                ?.historyData.carService.filter((data) => !!data.specialRequest)
                .map(
                    (data) => <MedpaceAutocompleteObject>{ requestDate: data.requestDate, value: data.specialRequest }
                ) ?? []
        ),
    }));

    public readonly timeOptions: Signal<MdsOptionGeneric<number>[]> = computed(
        () => this.travelViewModelService.travelCardViewModel()?.timeOptions ?? []
    );

    protected addTransfer() {
        this.formGroup().controls.transfers.push(
            TransferDataFormGroup.create({
                pickupAddress: '',
                dropoffAddress: '',
                pickupDate: null,
                pickupTime: null,
            })
        );
    }
    protected removeTransfer(index: number) {
        this.formGroup().controls.transfers.removeAt(index);
    }
}
